module.exports = __webpack_public_path__ + "img/equipe-black.bd26df4f.webp";